"use client"
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__checkbox_mjs_5e917cd4__ from "./checkbox.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__ from "./command.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__ from "./popover.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__ from "../lib/SIcon.mjs";
const ComboboxContext = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.createContext(void 0);
const useCombobox = ()=>{
    const context = __WEBPACK_EXTERNAL_MODULE_react__.useContext(ComboboxContext);
    if (!context) throw new Error("useCombobox must be used within a Combobox");
    return context;
};
const Combobox = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ defaultOpen = false, open: controlledOpen, onOpenChange, ...props }, ref)=>{
    const [uncontrolledOpen, setUncontrolledOpen] = __WEBPACK_EXTERNAL_MODULE_react__.useState(defaultOpen);
    const isControlled = void 0 !== controlledOpen;
    const open = isControlled ? controlledOpen : uncontrolledOpen;
    const handleOpenChange = __WEBPACK_EXTERNAL_MODULE_react__.useCallback((newOpen)=>{
        if (!isControlled) setUncontrolledOpen(newOpen);
        onOpenChange?.(newOpen);
    }, [
        onOpenChange
    ]);
    const value = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>({
            open,
            setOpen: handleOpenChange
        }), [
        open,
        handleOpenChange
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ComboboxContext.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.Popover, {
            open: open,
            onOpenChange: handleOpenChange,
            ...props
        })
    });
});
Combobox.displayName = "Combobox";
const highlightVariants = {
    default: "data-[state=open]:bg-highlight data-[state=open]:text-highlight-foreground",
    text: "data-[state=open]:text-highlight-foreground",
    secondary: "data-[state=open]:bg-background data-[state=open]:text-highlight-foreground"
};
const ComboboxTrigger = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, showHighlightOnOpen = true, preventDefault = false, onClick, ...props }, ref)=>{
    const { open, setOpen } = useCombobox();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverTrigger, {
        ref: ref,
        onClick: (e)=>{
            if (preventDefault) {
                e.preventDefault();
                e.stopPropagation();
                setOpen(!open);
            }
            onClick?.(e);
        },
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("focus:outline-none", showHighlightOnOpen && ("string" == typeof showHighlightOnOpen ? highlightVariants[showHighlightOnOpen] : highlightVariants.default), className),
        ...props
    });
});
ComboboxTrigger.displayName = "ComboboxTrigger";
const ComboboxContent = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, children, ...props }, ref)=>{
    const { value, filter, loop, label, shouldFilter, defaultValue, ...popoverProps } = props;
    const commandProps = {
        value,
        filter,
        loop,
        label,
        shouldFilter,
        defaultValue
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverContent, {
        ref: ref,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("w-fit p-0 rounded-xl overflow-hidden", className),
        ...popoverProps,
        onClick: (event)=>{
            event.stopPropagation();
        },
        onWheel: (event)=>{
            event.stopPropagation();
        },
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.Command, {
            ...commandProps,
            children: children
        })
    });
});
ComboboxContent.displayName = "ComboboxContent";
const ComboboxInput = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandInput, {
        ref: ref,
        wrapperClassName: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("flex w-full justify-start pl-0"),
        ...props
    }));
ComboboxInput.displayName = "ComboboxInput";
const ComboboxList = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandList, {
        ref: ref,
        ...props,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("p-1", props.className)
    }));
ComboboxList.displayName = "ComboboxList";
const ComboboxEmpty = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandEmpty, {
        ref: ref,
        className: "py-4",
        ...props
    }));
ComboboxEmpty.displayName = "ComboboxEmpty";
const ComboboxGroup = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandGroup, {
        ref: ref,
        ...props
    }));
ComboboxGroup.displayName = "ComboboxGroup";
const ComboboxSeparator = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandSeparator, {
        ref: ref,
        ...props,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("my-1")
    }));
ComboboxSeparator.displayName = "ComboboxSeparator";
const ComboboxItem = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, icon, selected, variant = "default", allowMultiSelect = false, ...props }, ref)=>{
    const { setOpen } = useCombobox();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandItem, {
        ref: ref,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("relative flex h-[30px] group/item cursor-default select-none items-center rounded-md font-normal px-2.5 text-sm outline-none text-foreground/[0.75] data-[disabled=true]:pointer-events-none data-[selected=true]:bg-grayscale-dark data-[selected=true]:text-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 transition-colors", "default" === variant && "gap-6 justify-between"),
        onSelect: async (value)=>{
            await props.onSelect?.(value);
            if (!allowMultiSelect || "checkbox" !== variant) setOpen(false);
        },
        ...(({ onSelect, ...rest })=>rest)(props),
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("flex items-center gap-2", className),
                children: [
                    "checkbox" === variant && allowMultiSelect && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__checkbox_mjs_5e917cd4__.Checkbox, {
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("!size-4 pointer-events-none !gap-0 transition-colors duration-100"),
                        checked: selected
                    }),
                    "checkbox" === variant && !allowMultiSelect && selected && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
                        size: 12,
                        type: "check",
                        className: "!size-3 text-brand-primary group-data-[selected=true]/item:text-brand-primary transition-colors"
                    }),
                    icon ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
                        size: 12,
                        type: icon,
                        className: "!size-3 text-brand-primary group-data-[selected=true]/item:text-brand-primary transition-colors"
                    }) : null,
                    props.children
                ]
            }),
            "default" === variant && selected && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("flex items-center justify-center opacity-0", selected && "opacity-100"),
                children: allowMultiSelect ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__checkbox_mjs_5e917cd4__.Checkbox, {
                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("!size-4 pointer-events-none !gap-0 transition-colors duration-100"),
                    checked: selected
                }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
                    size: 12,
                    type: "check",
                    className: "!size-3 text-brand-primary group-data-[selected=true]/item:text-brand-primary transition-colors"
                })
            })
        ]
    });
});
ComboboxItem.displayName = "ComboboxItem";
const ComboboxShortcut = __WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandShortcut;
const ComboboxAutofocus = ()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("button", {
        type: "button",
        autoFocus: true,
        "aria-hidden": "true",
        className: "sr-only"
    });
ComboboxAutofocus.displayName = "ComboboxAutofocus";
export { Combobox, ComboboxAutofocus, ComboboxContent, ComboboxEmpty, ComboboxGroup, ComboboxInput, ComboboxItem, ComboboxList, ComboboxSeparator, ComboboxShortcut, ComboboxTrigger, useCombobox };
